import React, { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import { getFieldShape, getFieldShapeAdmin } from "services";

import { matchGeoFirstAndLastCoords, useCancelAsyncOnUnmount, useTranslation } from "utils";

import { ErrorBoundary, Link, MapStatic, TablePanel } from "components";

export const TableFieldPanel = ({ field, badges, link, onClick, tag, isAdmin = false, dataTestId, showRedzoneColumn = false }) => {
  const signal = useCancelAsyncOnUnmount()();
  const [geometry, setGeometry] = useState();
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation("modules");

  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
    trackVisibility: true,
    delay: 100,
  });

  const loadFieldShape = useCallback(() => {
    const getFieldShapeFunction = isAdmin ? getFieldShapeAdmin : getFieldShape;

    getFieldShapeFunction({
      fieldId: field.id,
      signal,
    }).then((res) => {
      if (res.fieldShape) {
        const shape = matchGeoFirstAndLastCoords(res.fieldShape.geometry);
        setGeometry({ ...res.fieldShape, geometry: shape });
        setLoading(false);
      }
    });
  }, [field?.id, signal, isAdmin]);

  useEffect(() => {
    if (inView && field?.id && !geometry) {
      loadFieldShape();
    }
  }, [inView, field?.id, geometry, loadFieldShape]);

  const panel = (
    <div className="table-panel-title">
      <TablePanel
        dataTestId={dataTestId}
        headline={field.name}
        subtitle={field.number ? `Field #${field.number}` : "Field number unknown"}
        badges={badges}
        image={
          <div className="map-container" ref={ref}>
            {!loading && (
              <ErrorBoundary>
                <MapStatic field={field} geometry={geometry} location={field?.location} marker />
              </ErrorBoundary>
            )}
          </div>
        }
        tag={tag}
        onClick={onClick}
        extra={showRedzoneColumn ? <span className="paragraph-xs extra">{t("table.redzone")}</span> : null}
      />
    </div>
  );

  if (link) {
    return (
      <Link to={link} mixpanelText={"field-panel"} className={"field-panel"}>
        {panel}
      </Link>
    );
  }

  return panel;
};
